import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { selectMenuZIndex } from '../../../../styles/global';

type Props = {
  label: string;
  value?: string;
  onChange: (value: string) => void;
  disabled: boolean;
  id: string;
};

const NotificationDateInput = ({ id, label, value, onChange, disabled }: Props) => {
  const { i18n } = useTranslation();
  const theme = useTheme();
  const locale = i18n.language?.startsWith('pt') ? 'pt-br' : 'en';
  const placeholder = locale === 'pt-br' ? 'DD/MM/AAAA' : 'DD/MM/YYYY';

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
      <DateTimePicker
        value={value ? dayjs(value) : null}
        onChange={(date) => onChange(date?.isValid() ? date.format('YYYY-MM-DDTHH:mm') : '')}
        inputFormat="DD/MM/YYYY HH:mm"
        ampm={false}
        disabled={disabled}
        PopperProps={{ sx: { zIndex: selectMenuZIndex } }}
        DialogProps={{ sx: { zIndex: selectMenuZIndex } }}
        renderInput={(params) => (
          <TextField
            {...params}
            id={id}
            fullWidth
            size="small"
            inputProps={{
              ...params.inputProps,
              'aria-label': label,
              placeholder: `${placeholder} HH:mm`,
            }}
            sx={{
              '& .MuiInputBase-root': { backgroundColor: theme.colors.surface, color: theme.colors.onSurface },
              '& .MuiInputBase-input': { padding: '5px', fontSize: '0.9rem' },
              '& .MuiSvgIcon-root': { color: theme.colors.onSurface },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default NotificationDateInput;
